import { Expose, Type } from 'class-transformer'
import { Truck } from 'react-feather'

import { Pallet } from './Pallet'
import { FreightShipment } from './FreightShipment'

export class FreightShipmentPallet {
  static type = 'freightshipmentpallet'
  static typeDisplay = 'Pallet'
  static icon = Truck

  type = FreightShipmentPallet.type
  typeDisplay = FreightShipmentPallet.typeDisplay
  icon = FreightShipmentPallet.icon

  get guid() {
    return this.pallet?.guid
  }

  @Type(() => FreightShipment)
  shipment?: FreightShipment

  @Type(() => Pallet)
  pallet?: Pallet

  @Expose({ name: 'sscc_code' })
  ssccCode: string = ''

  @Expose({ name: 'pallet_label_data' })
  labelData: any = null
}
